import React from 'react'
import './GraphComponent.scss'
import D3_Chart from './d3-chart.js'
const d3_chart = new D3_Chart('#graph')

const PARAMS = {
  sp: {
    circle_min: 18,
    circle_max: 1,
    circle_exp: 1.2,
  },
  pc: {
    circle_min: 21,
    circle_max: 7,
    circle_exp: 1,
  },
}

class GraphComponent extends React.Component {
  componentDidMount() {
    d3_chart.create('#graph')
    d3_chart.updateParams(PARAMS)
    d3_chart.init(this.props.data)
  }
  shouldComponentUpdate(nextProps, nextStates) {
    // アップデート比較
    const is_updated = this.props.data.children.find((d, i) => {
      const nextMatched = nextProps.data.children[i].matched
      const is_data_diff = nextMatched !== d.matched
      const d_matched_thresh = d.matched >= window.JMOSettings.chart.THRESHOLD
      const next_matched_thresh = nextMatched >= window.JMOSettings.chart.THRESHOLD
      const anydata_overthresh = d_matched_thresh || next_matched_thresh
      return is_data_diff && anydata_overthresh
    })

    // データ更新がない場合処理を保留
    if (!is_updated && !nextProps.reset) {
      return false
    } else {
      d3_chart.update(nextProps.data)
      return true
    }
  }
  render() {
    return <div id="graph" />
  }
}

export default GraphComponent
